__webpack_require__.p = "/Platforms/Assetmanagement/";